export default ({ color, typography }) => ({
  calendarContainer: {
    maxHeight: 320,
    fontFamily: typography.bodyText,
    marginTop: 10,
    '& div.DayPicker': {
      marginLeft: 10,
    },
    '& ul': {
      marginLeft: 0,
      '& li.DayPicker_weekHeader_li': {
        fontWeight: 600,
        fontSize: 15,
      },
    },
    '& table': {
      '& td': {
        padding: 0,
      },
    },
    '& td': {
      border: '1px double transparent',
    },
    '& table.CalendarMonth_table': {
      boxShadow: 'none',
    },
    '& div.CalendarMonth_caption': {
      fontSize: 15,
      paddingTop: 25,
      color: color.primaryButtonBackground,
    },
    '& div.CalendarMonthGrid': {
      '& div.CalendarMonthGrid_month__horizontal:nth-child(2)': {
        borderRight: '1px solid lightgray',
      },
    },
    '& td.CalendarDay__default': {
      backgroundColor: 'white',
      color: color.primaryButtonBackground,
      border: '1px double transparent',
      '&:hover': {
        border: '1px double transparent',
        backgroundColor: '#CBF1FF',
      },
    },
    '& td.CalendarDay__selected_span': {
      backgroundColor: 'white',
      color: color.primaryButtonBackground,
      '&:hover': {
        border: '1px double transparent',
      },
    },
    '& td.CalendarDay__default.CalendarDay__blocked_out_of_range': {
      color: '#A0A0A0',
      '&:hover': {
        backgroundColor: '#F0F0F0',
      },
    },
    '& td.CalendarDay__default.CalendarDay__selected': {
      backgroundColor: color.primaryButtonBackground,
      color: 'white',
      border: `1px solid ${color.primaryButtonBackground}`,
      '&:hover': {
        backgroundColor: color.primaryButtonBackground,
        opacity: 1,
        color: 'white',
      },
    },
    '& div.DayPickerNavigation_rightButton__horizontalDefault': {
      backgroundColor: color.primaryButtonBackground,
      border: `1px solid ${color.primaryButtonBackground}`,
      '& svg': {
        fill: 'white',
      },
    },
    '& div.DayPickerNavigation_leftButton__horizontalDefault': {
      backgroundColor: color.primaryButtonBackground,
      border: `1px solid ${color.primaryButtonBackground}`,
      '& svg': {
        fill: 'white',
      },
    },
  },
});
